export default "__VITE_ASSET__8e9667ae__"